import { render, staticRenderFns } from "./u-pagination-text-rounded.vue?vue&type=template&id=a41e17b8&scoped=true&"
import script from "./u-pagination-text-rounded.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41e17b8",
  null
  
)

export default component.exports